"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validate = exports.ttsFields = exports.initialValues = exports.icon = exports.fields = void 0;
var _react = _interopRequireDefault(require("react"));
var _glass = _interopRequireDefault(require("cccisd-icons/glass"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var fields = exports.fields = ['name', 'content'];
var ttsFields = exports.ttsFields = ['content'];
var initialValues = exports.initialValues = {
  name: 'Menu Item',
  content: 'Menu Item'
};
var icon = exports.icon = /*#__PURE__*/_react["default"].createElement(_glass["default"], null);
var validate = exports.validate = function validate(values) {
  return {};
};